import { keys } from 'lodash'
import Color from 'canvas-sketch-util/color'

import colors from './constants/colors.json'

const _colors = {}
keys(colors).map((_k, _i) => {
  _colors[_k] = Color.parse(colors[_k]).hex
})

export default {
  colors: {
    ..._colors,
    text: _colors.white,
    background: _colors.black,
    primary: _colors.red
  },
  fonts: {
    body: `'Dia-Regular', sans-serif`
  },
  fontSizes: [14],
  fontWeights: {
    body: 400
  },
  lineHeights: ['16px'],
  space: [0, 5, 10, 15, 20],
  radii: [0, 5, 10],
  borderStyles: ['solid'],
  borderWidths: [1],
  text: {
    caps: {
      fontFamily: 'body',
      fontSize: 0,
      lineHeight: 0,
      fontWeight: 'body'
    }
  },
  styles: {
    root: {
      fontFamily: 'body'
    }
  }
}
